import gql from 'graphql-tag';

export default gql`
  subscription subscribeToNewConversationNote($conversationId: ID!) {
    subscribeToNewConversationNote(conversationId: $conversationId) {
      __typename
      id
      conversationId
      createdBy
      content
      author {
        cognitoId
        username
        userData
      }
    }
  }
`;
